export function isExpired(token: string | undefined | null): boolean {
	if (!token) return true;
	const isValid = isValidJwt(token);
	if (!isValid) {
		return true;
	}
	try {
		const payload = JSON.parse(atob(token.split('.')[1]));
		if (!payload.exp) return true;
		return Date.now() >= payload.exp * 1000;
	} catch {
		return true;
	}
}

function isValidJwt(token: string | undefined | null): boolean {
	if (!token) return false;
	const parts = token.split('.');
	if (parts.length !== 3) return false;
	try {
		const payload = atob(parts[1]);
		JSON.parse(payload);
		return true;
	} catch {
		return false;
	}
}
